import type { ProductItem } from '@app/_proto/Protos/products';
import { useComponentClasses } from '@app/components/hooks';
import { formatAmountForDisplay } from '@app/utils/utils';
import { Button } from '@mui/material';
import { YinYang } from 'mdi-material-ui';
import * as React from 'react';
import { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

export type KarmaProductType = {
    product: ProductItem;
    disabled?: boolean;
    onPurchase?: (product: ProductItem) => void;
};

export default function KarmaProduct({ product, disabled, onPurchase }: KarmaProductType) {
    const { MuiButton: buttonClasses } = useComponentClasses('MuiButton');

    const handleClickBuy = useCallback(() => {
        onPurchase?.(product);
    }, [onPurchase, product]);

    return (
        <div className="flex flex-1 flex-col items-center justify-center space-y-[5px]">
            <div className="flex w-full flex-1 justify-center space-x-[5px]">
                <div className="flex flex-1 items-center justify-end">
                    <YinYang className="text-[16px] text-[#ffe000]" />
                </div>
                <div className="flex-[2] text-left">
                    <span className="text-[18px] font-semibold">{product.quantity.toLocaleString()}</span>
                </div>
            </div>
            <span className="text-center text-[13px] font-semibold text-[#888]">Golden Karma</span>
            <span className="text-center text-[13px] font-semibold">{formatAmountForDisplay(product.price)}</span>
            <Button
                disabled={disabled}
                onClick={handleClickBuy}
                classes={{
                    ...buttonClasses,
                    root: twMerge(buttonClasses.root, 'h-[30px] w-[106px] !text-[13px] font-semibold'),
                }}
            >
                BUY
            </Button>
        </div>
    );
}
